module.exports = __webpack_public_path__ + "assets/img/5.be610f88.png";